var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLicenses = function SvgLicenses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.556 10.889c.377 0 .744.044 1.11.1V5.633L10.334 2 2 5.633v5.456C2 16.133 5.556 20.856 10.333 22c.611-.144 1.2-.356 1.778-.611a6.64 6.64 0 0 1-1.222-3.833 6.67 6.67 0 0 1 6.667-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.556 13.111a4.443 4.443 0 0 0-4.445 4.445A4.443 4.443 0 0 0 17.556 22 4.443 4.443 0 0 0 22 17.556a4.443 4.443 0 0 0-4.444-4.445m0 1.533A1.25 1.25 0 0 1 18.8 15.89c0 .678-.567 1.244-1.244 1.244a1.257 1.257 0 0 1-1.245-1.244 1.25 1.25 0 0 1 1.245-1.245m0 5.967a3.03 3.03 0 0 1-2.49-1.3c.056-.8 1.678-1.2 2.49-1.2.81 0 2.433.4 2.488 1.2a3.03 3.03 0 0 1-2.488 1.3"
  }))));
};
export default SvgLicenses;